import inView from 'in-view';
import lottie from 'lottie';

const SELECTOR = '.animated-svg';
var els = null;

function onDocumentReady() {
	els = document.querySelectorAll(SELECTOR);
	if (!els || els.length === 0) {
		return;
	}

	[...els].forEach(initAnimatedSVGElement);

	inView(SELECTOR).on('enter', onEnterView);
}

export function initAnimatedSVGElement(el, autoplay=false) {
	try {
		el.animation = lottie.loadAnimation({
			container: el,
			renderer: 'svg',
			path: el.getAttribute('data-animation'),
			autoplay
		});

		el.animation.addEventListener('DOMLoaded', () => {
			const svg = el.querySelector('svg');
			const viewbox = svg.getAttribute('viewBox').split(' ');
			const ratio = viewbox[2] / viewbox[3];
			el.style.height = (el.clientWidth / ratio) + 'px';
		});
	} catch (error) {
		console.error(error);
	}
}

function onEnterView(el) {
	el.animation.play();
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
